import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style/FeatureStepTabs.css';
import { FaCheck } from 'react-icons/fa';


import imageHow1 from '../assets/img/1.png';
import imageHow2 from '../assets/img/2.png';
import imageHow3 from '../assets/img/3.png';
import imageHow4 from '../assets/img/4.png';

export default function FeatureStepTabs() {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      label: t('step1'),
      title: t('how.step1Title'),
      text: t('how.step1Text'),
      img: imageHow1,
      number: '01',
    },
    {
      label: t('step2'),
      title: t('how.step2Title'),
      text: t('how.step2Text'),
      img: imageHow2,
      number: '02',
    },
    {
      label: t('step3'),
      title: t('how.step3Title'),
      text: t('how.step3Text'),
      img: imageHow3,
      number: '03',
    },
    {
      label: t('step4'),
      title: t('how.step4Title'),
      text: t('how.step4Text'),
      img: imageHow4,
      number: '04',
    },
  ];

  return (
    <div className="feature-tab-global-wrapper upload-multiple-container">
      <h2>{t('howTitle')}</h2>
      <p className="how-subtitle">{t('howSub')}</p>

      <div className="feature-tab-inner-box">
        <div className="feature-tabs-buttons">
          {steps.map((step, index) => (
            <button
              key={index}
              className={`feature-tab-button ${activeStep === index ? 'active' : ''}`}
              onClick={() => setActiveStep(index)}
            >
              {step.label}
            </button>
          ))}
        </div>

        <div className="feature-tab-content-row keyframe-wrapper" key={activeStep}>
        <div className="feature-tab-image slide-up">
          <img src={steps[activeStep].img} alt={steps[activeStep].title} />
        </div>
        <div className="feature-tab-text reveal-text">
          <div className="feature-step-number">{steps[activeStep].number}</div>
          <h3>{steps[activeStep].title}</h3>
          <p>{steps[activeStep].text}</p>

          {activeStep === 0 && (
            <ul className="custom-list reveal-text"> 
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step1List.1')}</li>
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step1List.2')}</li>
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step1List.3')}</li>
            </ul>
          )}
          
          {activeStep === 1 && (
            <ul className="custom-list reveal-text"> 
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step2List.1')}</li>
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step2List.2')}</li>
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step2List.3')}</li>
            </ul>
          )}

          {activeStep === 2 && (
            <ul className="custom-list reveal-text"> 
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step3List.1')}</li>
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step3List.2')}</li>
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step3List.3')}</li>
            </ul>
          )}

          {activeStep === 3 && (
            <ul className="custom-list reveal-text"> 
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step4List.1')}</li>
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step4List.2')}</li>
              <li className="reveal-text"><FaCheck className="check-icon" /> {t('how.step4List.3')}</li>
            </ul>
          )}

                    
        </div>
      </div>

      </div>
    </div>
  );
}
